export const chaninId = 999999999;

export const DEFAULT_VAL = '--';

export const PAGE_SIZE = 10;

export enum WalletMethod {
  AddEthereumChain = 'wallet_addEthereumChain',
}

export type ActivityChainInfo = typeof ACTIVITY_CHAIN_INFO;

export type ActivityChainInfoConfig =
  ActivityChainInfo[keyof ActivityChainInfo]['info'];

export const ACTIVITY_CHAIN_INFO = {
  // https://chainlist.org/?search=DeepBrainChain
  DBC: {
    id: 19880818,
    info: {
      chainId: '0x12f5b72',
      chainName: 'DeepBrainChain Mainnet',
      nativeCurrency: {
        name: 'DeepBrainChain',
        symbol: 'DBC',
        decimals: 18,
      },
      rpcUrls: ['https://rpc.dbcwallet.io'],
      blockExplorerUrls: ['https://www.dbcscan.io'],
    },
  },
  // https://chainlist.org/?search=imx
  IMX: {
    id: 13371,
    info: {
      chainId: '0x343b',
      chainName: 'Immutable zkEVM Mainnet',
      nativeCurrency: {
        name: 'Immutable zkEVM',
        symbol: 'IMX',
        decimals: 18,
      },
      rpcUrls: ['https://rpc.immutable.com'],
      blockExplorerUrls: ['https://explorer.immutable.com'],
    },
  },
  // MON链先注释掉
  // https://chainlist.org/?search=Monad+Testnet&testnets=true
  MON: {
    id: 10143,
    info: {
      chainId: '0x279F',
      chainName: 'Monad Testnet',
      nativeCurrency: {
        name: 'MonadTestnetChain',
        symbol: 'MON',
        decimals: 18,
      },
      rpcUrls: ['https://testnet-rpc.monad.xyz/'],
      blockExplorerUrls: ['https://testnet.monadexplorer.com'],
    },
  },
  // https://chainlist.org/?search=Monad+Testnet&testnets=true
  CELO: {
    id: 42220,
    info: {
      chainId: '0xa4ec',
      chainName: 'Celo Mainnet',
      nativeCurrency: {
        name: 'CeloMainnetChain',
        symbol: 'CELO',
        decimals: 18,
      },
      rpcUrls: ['https://forno.celo.org'],
      blockExplorerUrls: ['https://celo.blockscout.com/'],
    },
  },
};
